<mat-select>
  <mat-option>
    <ngx-mat-select-search
      placeholderLabel="{{ 'BUTTONS.SEARCH' | translate }}"
      noEntriesFoundLabel=""
      [formControl]="timezoneFilter"
      (ngModelChange)="filterTimezones($event)"
    ></ngx-mat-select-search>
  </mat-option>
  @for (timezone of filteredTimezones; track timezone.id) {
  <mat-option [value]="timezone.id">{{ timezone.displayName }}</mat-option>
  }
</mat-select>
